import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-layout',
  imports: [CommonModule],
  templateUrl: './layout-lead.html',
  styleUrl: './layout.css',
})
export class LayoutComponent {
}

